<template>
  <div>
    <d-card-header class="border-bottom flex-header">
      <h6 class="m-0">Warunki umowy</h6>
      <c-dropdown
        label="Dodaj warunek"
        theme="success"
        @select-basic="handleBasicConditionPicked"
      />
    </d-card-header>

    <template v-if="conditions.length > 0">
      <d-list-group-item class="text-center">
        <table class="table mb-0 responsive-table" style="border: 1px #dee2e6 solid;table-layout: fixed;">
          <thead class="bg-light">
            <tr>
              <th scope="col" class="border-0">Warunek</th>
              <th scope="col" class="border-0">Data spełnienia</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(condition, index) in conditions" :key="index">
              <td class="align-middle text-left">
                <dt>Warunek</dt>
                <dd>{{ condition.description }}</dd>
              </td>
              <td class="align-middle">
                <dt>Data spełnienia</dt>
                <dd>{{ condition.completion_date ? condition.completion_date.slice(0, 10) : '-' }}</dd>
              </td>
            </tr>
          </tbody>
        </table>
      </d-list-group-item>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CDropdown from '@/components/contracts/conditions/molecules/CDropdown.vue';

export default {
  name: 'ContractConditionsList',
  components: {
    CDropdown,
  },
  props: {
    scheduleConditions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      conditions: [],
    };
  },
  computed: {
    ...mapGetters([
      'getBasicConditionById',
    ]),
  },
  methods: {
    handleBasicConditionPicked({ id, date }) {
      const basicCondition = this.getBasicConditionById(id);
      if (!this.conditions) {
        this.conditions = [];
      }
      this.conditions.push({
        description: basicCondition.value,
        completion_date: date,
        status: 0,
      });
      this.$emit('conditions-changed', this.conditions);
    },
  },
  mounted() {
    // Inicjalizacja warunków z propsów
    if (this.scheduleConditions && this.scheduleConditions.length > 0) {
      this.conditions = [...this.scheduleConditions];
    }
  },
  watch: {
    scheduleConditions: {
      handler(newVal) {
        if (newVal && Array.isArray(newVal)) {
          this.conditions = [...newVal];
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>

